export const iconFontAwesomePoliticalScaleBalanced = (
	<i className="fa-solid fa-scale-balanced"></i>
);
